<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Validator",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_validator",
      },
      {
        width: "auto",
        label: "nama",
        name: "name",
      },
      {
        width: "200px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Validator";

    return {
      title: menu,
      // isWrite: localStorage.getItem("isWrite"),
      isWrite: 1,
      showModal: false,
      isEdit: false,
      selected_id: "",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_validator", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_validator",
        dir: "desc",
        filter: {
          active_flag: 1,
          iduser_logins: null,
        },
      },

      form: {
        iduser_logins: null,
        user: null,
        nomor_rekening: "",
        npwp: "",
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      optionUser: [],
      optionValidatorFilter: [],
    };
  },
  async mounted() {
    await this.getDataTable();
    this.getUser();
    this.getValidatorFilterOptions();
    this.filterUser = _.debounce(this.searchUser.bind(this), 500);
    this.filterSearch = _.debounce(this.onSearchInput.bind(this), 500);
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/validator",
    ) {
      this.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            console.log(response_data_fix);
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => (this.loadingTable = false));
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable();
    },
    resetForm() {
      this.form = {
        iduser_logins: null,
        user: null,
        nomor_rekening: "",
        npwp: "",
      };
      this.selected_id = "";
    },
    create() {
      this.resetForm();
      this.isEdit = false;
      this.showModal = true;
    },
    edit(data) {
      this.isEdit = true;
      this.selected_id = data.idverif_validator;
      this.form = {
        iduser_logins: data.iduser_logins,
        user: data.user,
        nomor_rekening: data.nomor_rekening,
        npwp: data.npwp,
      };
      this.showModal = true;
    },
    save() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/validator";
      let method = "post";

      if (this.isEdit) {
        url += "/" + this.selected_id;
        method = "put";
      }

      Swal.fire({
        title: "Sedang memproses data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      this.form.iduser_logins = this.form.user?.user_id;
      axios({
        method: method,
        url: url,
        data: this.form,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            this.showModal = false;
            this.getDataTable();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          let message = "Terjadi kesalahan";

          const metaMessage = error?.response?.data?.meta?.message;
          const validationErrors = error?.response?.data?.data?.error;

          if (
            metaMessage === "Validation failed" &&
            Array.isArray(validationErrors)
          ) {
            message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
          } else if (metaMessage) {
            message = metaMessage;
          }

          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message, // pakai html, bukan text
          });
        });
    },
    changeStatus(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/validator/" +
        data.idverif_validator +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/validator/" +
        data.idverif_validator;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    async searchUser(search, loading) {
      loading(true);
      await this.getUser(search, loading);
    },
    async getUser(search = "", loading) {
      await axios
        .get(process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/user/all", {
          params: {
            search: search,
            limit: 200,
          },
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        })
        .then((response) => {
          this.optionUser = response.data.data.data;
          if (loading) loading(false);
        });
    },
    async getValidatorFilterOptions() {
      try {
        const response = await axios.get(
          process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/validator",
          {
            params: { per_page: 500, filter: { active_flag: 1 } },
            headers: {
              Authorization: "Bearer " + localStorage.access_token,
            },
          }
        );
        if (response.data.meta.code === 200) {
          const list = response.data.data?.data || [];
          this.optionValidatorFilter = list.map((item) => ({
            iduser_logins: item.iduser_logins,
            name: item.name + (item.username ? ` (${item.username})` : ""),
          }));
        }
      } catch (err) {
        console.log("Error getValidatorFilterOptions:", err);
      }
    },
    onFilterChange() {
      this.tableFilter.page = 1;
      this.getDataTable();
    },
    onSearchInput() {
      this.tableFilter.page = 1;
      this.getDataTable();
    },
    resetFilter() {
      this.tableFilter.search = "";
      this.tableFilter.filter.iduser_logins = null;
      this.tableFilter.filter.active_flag = 1;
      this.tableFilter.page = 1;
      this.getDataTable();
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <!-- <div class="card-title">List Data</div> -->
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="create()"
                    v-if="isWrite || isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2 g-3 align-items-end">
              <hr class="mt-0" />
              <!-- Status Filter -->
              <div class="form-group col-md-3">
                <label for="filterStatus" class="form-label fw-semibold">Status</label>
                <select
                  class="form-control"
                  id="filterStatus"
                  v-model="tableFilter.filter.active_flag"
                  @change="onFilterChange()"
                >
                  <option value="">Semua Status</option>
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>

              <!-- Dropdown Search Validator -->
              <div class="form-group col-md-4">
                <label class="form-label fw-semibold">Pilih Validator (Dropdown Search)</label>
                <v-select
                  class="style-chooser"
                  :options="optionValidatorFilter"
                  :reduce="(item) => item.iduser_logins"
                  label="name"
                  v-model="tableFilter.filter.iduser_logins"
                  placeholder="Semua Validator (Ketik untuk cari...)"
                  :clearable="true"
                  @update:modelValue="onFilterChange()"
                />
              </div>

              <!-- Text Search Input -->
              <div class="form-group col-md-3">
                <label for="filterSearch" class="form-label fw-semibold">Cari Data</label>
                <div class="input-group">
                  <span class="input-group-text bg-light"><i class="fa fa-search text-muted"></i></span>
                  <input
                    type="text"
                    class="form-control"
                    id="filterSearch"
                    placeholder="Cari nama, rekening, npwp..."
                    v-model="tableFilter.search"
                    @input="filterSearch()"
                  />
                </div>
              </div>

              <!-- Reset Button -->
              <div class="form-group col-md-2">
                <button
                  type="button"
                  class="btn btn-outline-secondary w-100"
                  @click="resetFilter()"
                  title="Reset Filter"
                >
                  <i class="fa fa-rotate-left me-1"></i> Reset
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td class="text-center" colspan="99">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="99">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td>{{ key_data + pagination.from }}</td>
                  <td>
                    {{ row_data.name }}
                  </td>
                  <td class="text-center">
                    <div class="btn-group">
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                        v-on:click="edit(row_data)"
                      >
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-trash"></i> Disable
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-recycle"></i> Enable
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                        v-on:click="deleteData(row_data)"
                      >
                        <i class="fa fa-trash"></i> Hapus
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Validator' : 'Tambah Validator'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <form @submit.prevent="save">
        <div class="form-group mb-3">
          <label>User <span class="text-danger">*</span></label>
          <v-select
            :options="optionUser"
            label="name"
            v-model="form.user"
            placeholder="User"
            @search="filterUser"
          />
        </div>
        <div class="form-group mb-3">
          <label>Nomor Rekening</label>
          <input
            v-model="form.nomor_rekening"
            type="text"
            class="form-control"
            placeholder="Masukkan Nomor Rekening"
          />
        </div>
        <div class="form-group mb-3">
          <label>NPWP</label>
          <input
            v-model="form.npwp"
            type="text"
            class="form-control"
            placeholder="Masukkan NPWP"
          />
        </div>
        <div class="text-end mt-4">
          <button
            type="button"
            class="btn btn-light me-1"
            @click="showModal = false"
          >
            Tutup
          </button>
          <button type="submit" class="btn btn-success">Simpan</button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
